<template>
  <div>
  <div class="row">
    <div class="col-6 col-lg-3 mb-3 mb-lg-0">
      <order-analytics-block color="bg-dark text-white" card-style="border-dark">
        <template #header>{{ timeDisplay.unit.toUpperCase() }}</template>
        {{ timeDisplay.value }}
      </order-analytics-block>
    </div>

    <div class="col-6 col-lg-3 mb-3 mb-lg-0">
      <order-analytics-block color="bg-info text-white" card-style="border-info">
        <template #header>
          <span class="d-none d-lg-block d-xl-none">PM</span>
          <small class="d-block d-lg-none d-xl-block">Profit Margin</small>
        </template>
        {{ Math.round(parseFloat(net) / parseFloat(total).toFixed(2) * 100) }}%
      </order-analytics-block>
    </div>

    <div class="col-6 col-lg-3 mb-3 mb-lg-0">
      <order-analytics-block color="bg-success-subtle" card-style="border-success-subtle">
        <template #header>ROI <sup>*</sup></template>
        {{ roi }}
      </order-analytics-block>
    </div>

    <div class="col-6 col-lg-3 mb-3 mb-lg-0">
      <order-analytics-block color="bg-success text-white" card-style="border-success">
        <template #header>NET</template>
        <money-block :dollar="net" />
      </order-analytics-block>
    </div>

  </div>

    <div class="text-center mt-2">
      <em class="small text-muted">
        <sup>*</sup>
        ROI excludes free / $0-cost items.
      </em>
    </div>

  </div>
</template>

<script setup>
import { defineProps, toRefs, computed } from "vue";
import MoneyBlock from "@/app/components/Utils/MoneyBlock.vue";
import OrderAnalyticsBlock from "@/app/components/orders/OrderAnalyticsBlock.vue";
import { flipTimeBreakdown } from "@/services/dateUtils";

const props = defineProps(['net', 'cogs', 'days', 'minutes', 'total'])
const { net, cogs, days, minutes, total } = toRefs(props)

const timeDisplay = computed(() => {
  const mins = parseInt(minutes.value)
  if (!isNaN(mins) && mins >= 0) return flipTimeBreakdown(mins)
  return { value: parseInt(days.value) || 0, unit: 'days' }
})

const roi = computed(() => {
  if (!cogs.value || parseFloat(cogs.value) === 0) {
    return 'N/A'
  }
  return `${Math.round(parseFloat(net.value) / parseFloat(-cogs.value).toFixed(2) * 100)}%`
})
</script>
